var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { SingleSearchableDropdown } from '../filter.service';
import { HelperService } from '../helper.service';
import { OrderService } from '../../app/order-service.service';
import { Router } from '@angular/router';
import { ToasterService } from '../toaster.service';
import { Toaster, ToasterType } from '../shared/types';
import { LoaderService } from '../loader.service';
import { ORDERS_QOS } from '../shared/constants';
var SEARCH_BY = {
    ORDER_ID: 'orderId',
    MOBILE: 'mobile',
    EMAIL: 'email',
};
var OrderSearchComponent = /** @class */ (function () {
    function OrderSearchComponent(router, toasterService, orderService, loaderService) {
        var _this = this;
        this.router = router;
        this.toasterService = toasterService;
        this.orderService = orderService;
        this.loaderService = loaderService;
        this.placeholder = 'Search By OrderId';
        this.focus = false;
        this.enteredValue = '';
        this.SEARCH_BY = SEARCH_BY;
        this.filterTypeSelect = new SingleSearchableDropdown({
            key: 'value',
            title: '',
            values: [
                // SEARCH_BY.MOBILE,
                // SEARCH_BY.EMAIL,
                SEARCH_BY.ORDER_ID,
            ],
            default: SEARCH_BY.MOBILE,
            onChange: function (event) {
                console.log(event);
                var filterType = event.value;
                _this.searchBy = filterType;
            }
        });
    }
    OrderSearchComponent.prototype.ngOnInit = function () {
    };
    OrderSearchComponent.prototype.notFoundError = function () {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: "Not Found",
        }));
    };
    OrderSearchComponent.prototype.showError = function (message) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: message,
        }));
    };
    OrderSearchComponent.prototype.showLoading = function () {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.SUCCESS,
            message: "Loading",
        }));
    };
    OrderSearchComponent.prototype.search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var orderDate, payload, res, orderId, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.loaderService.openLoading();
                        return [4 /*yield*/, HelperService.getOrderDateyUniqueId(this.searchKeyword)];
                    case 1:
                        orderDate = _a.sent();
                        if (!orderDate) {
                            // this.showError("Invalid Order ID");
                            throw "Invalid Order ID";
                        }
                        payload = {
                            'limit': 1,
                            'searchConditions': {
                                'uniqueId': this.searchKeyword,
                                orderDate: orderDate,
                            },
                            'requiredFields': ['uniqueId'],
                            'qos': ORDERS_QOS.qos1
                        };
                        res = void 0;
                        this.showLoading();
                        return [4 /*yield*/, this.orderService.getOrders(payload).toPromise()];
                    case 2:
                        res = _a.sent();
                        if (!(res && res.orders && res.orders.length && res.orders[0] && res.orders[0]._id)) {
                            throw "Order Not Found";
                        }
                        orderId = res.orders[0] && res.orders[0]._id;
                        document.location.href = "order/" + orderId;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        if (typeof err_1 === "string") {
                            this.showError(err_1);
                            return [2 /*return*/];
                        }
                        this.notFoundError();
                        return [3 /*break*/, 5];
                    case 4:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return OrderSearchComponent;
}());
export { OrderSearchComponent };
